import React, { useState, useEffect } from 'react';
//@ts-ignore
import * as styles from './ProductSideBySide.module.css';
//@ts-ignore
import ArrowLgButton from '../Global/ArrowLgButton';
import { getMediaData } from '../Global/DataUtils';
import { ProductPagePreview } from '../Global/DataUtils/productQueries';
import { ProductSideBySideProps } from './index';
import { BuildLinkHref } from '../Global/BuildLinkHref';
//@ts-ignore
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import RichText from '../Global/RichText';
import {
    ProductDescription,
    ProductDetailMastheadData,
    ProductSpecifications,
} from '../../templates/StructuredDataContext';
import PlainTextElement from '../Global/Headlines';
import {
    defaultDomainCountryCodes,
    countriesList,
} from '../../global/countries';
interface Props extends ProductSideBySideProps {
    content: ProductPagePreview[];
}

const ProductSideBySide: React.FC<Props> = ({ headline, ...props }) => {
    const breakpoints = useBreakpoint();
    const [currentProductPage, setCurrentProductPage] = useState(0);
    const productsToShow = setProductsToShow(breakpoints);
    const [currentPosition, setCurrentPosition] = useState(0);
    const selectProductPages = props.content?.slice(
        currentPosition,
        currentPosition + productsToShow
    );

    const [selectedProductPages, setSelectedProductPages] =
        useState(selectProductPages);

    const dotsToShow = breakpoints.sm
        ? Math.ceil(props.content?.length / productsToShow)
        : props.content?.length;

    const description = props.description;

    useEffect(() => {
        setSelectedProductPages(props.content?.slice(0, productsToShow));
        setCurrentPosition(0);
        setCurrentProductPage(0);
    }, [productsToShow]);

    const handleClickNext = () => {
        let newProductPage = currentProductPage + 1;
        let newPosition = currentPosition + productsToShow;

        let newSelectedProducts = props.content?.slice(
            newPosition,
            newPosition + productsToShow
        );

        setSelectedProductPages(newSelectedProducts);
        setCurrentPosition(newPosition);
        setCurrentProductPage(newProductPage);
    };

    const handleClickPrev = () => {
        let newProductPage = currentProductPage - 1;
        let newPosition = currentPosition - productsToShow;

        let newSelectedProducts = props.content?.slice(
            newPosition,
            newPosition + productsToShow
        );

        setSelectedProductPages(newSelectedProducts);
        setCurrentPosition(newPosition);
        setCurrentProductPage(newProductPage);
    };

    const renderPrevButton = () => (
        <ArrowLgButton
            strokeColor="#f06623"
            direction="left"
            handleClick={handleClickPrev}
            className={styles.prevArrowButton}
        />
    );

    const renderNextButton = () => (
        <ArrowLgButton
            strokeColor="#f06623"
            direction="right"
            handleClick={handleClickNext}
            className={styles.nextArrowButton}
        />
    );

    const renderDots = (dotsToShow: number, currentProductPage: number) => {
        let dots = [];

        for (let i = 0; i < dotsToShow; i++) {
            dots.push(
                <span
                    key={i}
                    style={
                        currentProductPage == i ? { background: '#ccc' } : {}
                    }
                ></span>
            );
        }

        return dots;
    };

    const renderProductPageCard = (
        productPageCard: ProductPagePreview,
        cardIdx: number
    ) => {
        var productUrl = productPageCard.elements?.slug?.url;
        if (
            productPageCard?.elements?.slug?.url &&
            productPageCard?.preferred_language
        ) {
            let splittedPagePath =
                productPageCard?.elements?.slug?.url?.split('/');
            let splittedPagePathCountryCode =
                productPageCard?.elements?.slug?.url?.split('/')[1];
            //@ts-ignore
            const saunaPagePathContainsCountrySlug: boolean =
                countriesList.indexOf(splittedPagePathCountryCode) > -1
                    ? true
                    : false;
            if (saunaPagePathContainsCountrySlug) {
                let pagePathWithoutCountryCode =
                    '/' + splittedPagePath.slice(2).join('/');
                productUrl = pagePathWithoutCountryCode;
            }
            if (
                defaultDomainCountryCodes.indexOf(
                    productPageCard?.preferred_language.toLowerCase()
                ) == -1
            ) {
                productUrl =
                    '/' +
                    productPageCard?.preferred_language.toLowerCase() +
                    productUrl;
            }
        }
        const productSpecifications =
            productPageCard.elements?.page_components.value.filter(
                (component) =>
                    component.__typename ===
                    'kontent_item_component___product_specifications'
            )[0] as ProductSpecifications;
        const productDescription =
            productPageCard.elements?.page_components.value.filter(
                (component) =>
                    component.__typename ===
                    'kontent_item_component___product_description'
            )[0] as ProductDescription;
        const productDetailMasthead =
            productPageCard.elements?.page_components.value.filter(
                (component) =>
                    component.__typename ===
                    'kontent_item_component___product_detail_masthead'
            )[0] as ProductDetailMastheadData;

        const productCapacity =
            productSpecifications?.elements?.specs?.value[0]?.elements.capacity
                ?.value[0]?.elements?.capacity_value?.value;
        const aslowastext =
            productSpecifications?.elements?.specs?.value[0]?.elements
                ?.financing_info_copy?.value;

        const aslowasprice =
            productSpecifications?.elements?.specs?.value[0]?.elements
                ?.financing_cost?.value;
        const productCapacityIcon =
            productSpecifications?.elements?.specs?.value[0]?.elements.capacity
                ?.value[0]?.elements?.icon?.value[0]?.elements?.icon_svg_file
                .value[0]?.url;

        const productImage = getMediaData(
            productSpecifications?.elements?.gallery_images
        );

        return (
            <a href={productUrl} key={cardIdx} className={styles.productCard}>
                <img className={styles.productImage} src={productImage?.url} />
                <h5 className={styles.productName}>
                    {productDetailMasthead?.elements.display_headline?.value}
                </h5>
                {productCapacityIcon && <img src={productCapacityIcon} />}
                <div className={styles.capacity}>
                    <p>{productCapacity} Person Capacity</p>
                    {aslowasprice && aslowastext && (
                        <p>
                            {aslowastext}{' '}
                            <span style={{ fontWeight: 'bold' }}>
                                {aslowasprice}
                            </span>
                        </p>
                    )}
                </div>
            </a>
        );
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                {headline?.value && (
                    <h2>
                        <PlainTextElement text={headline} />
                    </h2>
                )}

                <div className={styles.description}>
                    {RichText(description)}
                </div>
            </div>
            <div id={styles.galleryWrapper} className={styles.content}>
                <div id={styles.gallery} className={styles.gallery}>
                    {currentProductPage > 0 && renderPrevButton()}
                    <div className={styles.galleryProducts}>
                        {selectedProductPages?.map(
                            (ProductPagePreview, cardIdx) => {
                                return renderProductPageCard(
                                    ProductPagePreview,
                                    cardIdx
                                );
                            }
                        )}
                    </div>

                    {props.content?.length > currentPosition + productsToShow &&
                        renderNextButton()}
                </div>

                {dotsToShow > 1 && (
                    <div className={styles.dots}>
                        {renderDots(dotsToShow, currentPosition)}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProductSideBySide;

function setProductsToShow(breakpoints: { [key: string]: boolean }) {
    switch (true) {
        case breakpoints.xl:
            if (document && document.body.offsetWidth > 1400) {
                return 5;
            }
            return 4;
        case breakpoints.l:
            return 3;
        case breakpoints.md:
            return 2;
        case breakpoints.sm:
            return 1;
        default:
            return 1;
    }
}
